/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Magnify_TitleInputs */



/**
* | output |
* | --- |
* | "Magnify Preview" |
*
* @param {Image_Export_Preview_Magnify_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_magnify_title = /** @type {((inputs?: Image_Export_Preview_Magnify_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Magnify_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Agrandir la previsualisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschau vergrößern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ingrandisci Anteprima")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Увеличить Предварительный просмотр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ampliar vista previa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("放大预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("拡大プレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ज़ूम करके पूर्वावलोकन देखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ampliar pré-visualização")
	return /** @type {LocalizedString} */ ("Magnify Preview")
});